import { TextField } from '@mui/material';
import { memo } from 'react';
import useSelloutDistributionQuantityInputStyles from '../styles/selloutDistributionQuantityInput.styles';
import { SelloutDistributionQuantityInputProps } from '../types/selloutDistributionQuantityInput.types';

interface SelloutDistributionQuantityInputTextFieldProps
  extends SelloutDistributionQuantityInputProps {}

const SelloutDistributionQuantityInputTextField = ({
  pieces,
  disabled,
  onChangePieces,
}: SelloutDistributionQuantityInputTextFieldProps) => {
  const { classes } = useSelloutDistributionQuantityInputStyles();

  return (
    <TextField
      fullWidth
      size="small"
      type="number"
      variant="outlined"
      disabled={disabled}
      className={classes.textField}
      value={disabled ? '' : pieces}
      onFocus={(e) => e.target.select()}
      onChange={(e) => onChangePieces(Number(e.target.value) || 0)}
      slotProps={{
        htmlInput: { inputMode: 'numeric', min: 0, max: Number.MAX_SAFE_INTEGER },
      }}
    />
  );
};

export default memo(SelloutDistributionQuantityInputTextField);
